import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// POST /api/admin/mdf/requests/:id/decline { reason }
//
// Replaces /app/admin/mdf/_actions.ts::declineRequestAction. Pessimistic
// with confirmation modal + reason input at the page layer. Service-side
// fan-out: dispatches MDF_REQUEST_DECLINED via notifications + posts a
// HubSpot Note (fire-and-forget). The reason text persists on
// `mdf_requests.declined_reason` and surfaces to the partner.
type Vars = { id: string; fundId: string; reason: string };

export function useDeclineRequest() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, Vars>({
    mutationFn: ({ id, reason }) =>
      apiFetch<{ ok: true }>(`/admin/mdf/requests/${id}/decline`, {
        method: "POST",
        body: JSON.stringify({ reason }),
      }),
    onSuccess: (_data, { id, fundId }) => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.mdf.requests() });
      void queryClient.invalidateQueries({ queryKey: queryKeys.mdf.request(id) });
      void queryClient.invalidateQueries({ queryKey: queryKeys.mdf.fund(fundId) });
      toast.success("Request declined");
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to decline request");
    },
  });
}
